export default __webpack_public_path__ + "static/brcc-image-left-1-270dc1d7a39434dee364c1c0e26e9800.avif";